import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=41d49e20&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d49e20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41d49e20')) {
      api.createRecord('41d49e20', component.options)
    } else {
      api.reload('41d49e20', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=41d49e20&scoped=true&", function () {
      api.rerender('41d49e20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4xZMY1aiN6FwV/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports